module.exports = __webpack_public_path__ + "static/media/shopper-groups-2.6833ad2d.png";